import { Component } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { CommunicationEquipment } from '@models/imported/SagaSchema/CommunicationEquipment';
import { AssociationSecurity, DEVICE_SECURITY_KEY } from '@services/association-security/association-security.service';
import { GlobalizationService } from '@services/globalization/globalization.service';
import { Security } from '@services/security/security.service';
import { AppSettingsService } from '@services/settings';
import { zip } from 'rxjs';

@Component({
  templateUrl: 'settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {
  updateBaseUrl: string;
  language: string;
  platformLanguage: string;
  cameraQuality: number;
  equipment: CommunicationEquipment;

  get deviceName(): string {
    return this.security.getSecurityData<string>(DEVICE_SECURITY_KEY);
  }

  constructor(
    private settingsService: AppSettingsService,
    private globalization: GlobalizationService,
    private modalCtrl: ModalController,
    private platform: Platform,
    private security: Security,
    private association: AssociationSecurity
  ) {}

  async ionViewWillEnter() {
    if (this.platform.is('cordova')) {
      zip(
        this.settingsService.getPlatformLanguage(),
        this.settingsService.language(true),
        this.settingsService.updateBaseUrl(),
        this.settingsService.getCameraQuality()
      ).subscribe(res => {
        this.platformLanguage = res[0] as string;
        this.language = res[1] as string;
        this.updateBaseUrl = res[2] as string;
        this.cameraQuality = res[3] as number;
      });
    } else {
      this.platformLanguage = navigator.language;
      this.language = localStorage.getItem('lang') || this.platformLanguage;
      this.cameraQuality = parseInt(localStorage.getItem('quality'), 10) || 90;
    }

    this.equipment = this.association.getDevice();
  }

  clearData() {
    this.security.clearSecurityData();
    window.location.reload();
  }

  showServers() {}

  settingChange(name: string, value: any) {
    this.settingsService.set(name, value);

    if (name === 'lang') {
      if (value === 'platform') {
        value = this.platformLanguage;
      }
      this.globalization.setLanguage(value);
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
